import ConvertToChartPropsException from './ConvertToChartPropsException';
import {ConversionOutput, SuccessfulConversionOutput} from './PropConverterTypes';

export default function maybeConvertProps<TChartProps>(
  conversionFn: () => SuccessfulConversionOutput<TChartProps>
): ConversionOutput<TChartProps> {
  try {
    return conversionFn();
  } catch (error) {
    if (error instanceof ConvertToChartPropsException) {
      return {
        valid: false,
        message: error.message,
      };
    } else {
      throw error;
    }
  }
}
